import { render, staticRenderFns } from "./Test1.vue?vue&type=template&id=7351c8de&scoped=true&"
import script from "./Test1.vue?vue&type=script&lang=js&"
export * from "./Test1.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./Test1.vue?vue&type=style&index=1&id=7351c8de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7351c8de",
  null
  
)

export default component.exports